import { Link } from 'react-router-dom'
import { Button } from '@orisini/ui/components/button'

const TAUTAN = [
  { href: '#products', label: 'Products' },
  { href: '#how-it-works', label: 'How it works' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#download', label: 'Download' },
]

/** Navigasi halaman depan. Publik: tidak ada satu pun tautan yang butuh sesi. */
export function SitusNav() {
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background">
      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center gap-x-8 gap-y-1 px-6 py-3">
        <Link
          to="/"
          className="flex items-center gap-2.5 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
        >
          <img src="/favicon.svg" alt="" className="size-6" />
          <span className="text-base font-semibold tracking-tight">Orisini</span>
        </Link>

        {/* Di layar sempit tautannya turun ke baris kedua alih-alih disembunyikan:
            itu satu-satunya jalan pintas menuju harga dan unduhan. */}
        <nav className="order-last -ml-2.5 flex w-full flex-wrap gap-1 md:order-none md:ml-0 md:w-auto">
          {TAUTAN.map((t) => (
            <a
              key={t.href}
              href={t.href}
              className="rounded-md px-2.5 py-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            >
              {t.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <Button asChild variant="ghost" size="sm">
            <Link to="/login">Sign in</Link>
          </Button>
          <Button asChild size="sm">
            <Link to="/register">Create account</Link>
          </Button>
        </div>
      </div>
    </header>
  )
}
